<template>
  <div class="fundo fill-height"
    :style="fundo">
  <v-container fixed fill-height >
    <v-layout row flex align-center justify-center>
      <v-flex xs12 sm6 class="elevation-12">
        <v-card>
          <v-card-title class="title primary--text">
            PORTAL DE RESULTADOS
          </v-card-title>
          <v-card-media v-if="logoApp" :src="logoApp" height="120px" contain>
          </v-card-media>
          <v-card-text>
            <v-container>
              <form @submit.prevent="login">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="username"
                      label="Login"
                      id="username"
                      v-model="username"
                      type="username"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      label="Senha"
                      id="password"
                      v-model="password"
                      required
                      :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"
                      :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="primary">Entrar</v-btn>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      :timeout="timeoutAlerta"
      :color="tipoAlerta"
      v-model="snackbar">
      {{ textAlerta }}
      <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
   
  </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import color from 'color'

  export default {
    data () {
      return {
        username: '',
        password: '',
        mostrarSenha: true,
        snackbar: false,
        tipoAlerta: '',
        timeoutAlerta: 6000,
        textAlerta: ''
      }
    },
    methods: {
      login () {
        var self = this
        var redirect = self.$route.query.redirect
        console.log('redirect ' + redirect)
        axios.defaults.headers.common['X-Auth-Token'] = ''
        axios.post('/login', {username: this.username, password: this.password})
        .then(function (response) {
          console.log(response.data)
          window.localStorage.setItem('user', JSON.stringify(response.data))
          self.$store.commit('changeUser', {user: response.data})
          if (redirect == null) {
            redirect = '/'
          }
          self.$store.commit('changeMenu', {})
          console.log('redirect ' + redirect)
          self.$router.push({path: redirect})
        })
        .catch(e => {
          self.tipoAlerta = 'error'
          self.textAlerta = 'Usuário ou senha inválidos.'
          self.snackbar = true
        })
      }
    },
    computed: {
      logoApp () {
        return this.$store.state.cabecalho.logo
      },
      fundo () {
        let cor = '#5e35b1'
        if (this.$store.state.cabecalho.cor) {
          cor = this.$store.state.cabecalho.cor
        }
        let cor1 = color(cor).alpha(1)
        let cor2 = color(cor).alpha(0.7)
        let cor3 = color(cor).alpha(1)
        return `background: linear-gradient(${cor1} 1%, ${cor2} 50%, ${cor3} 99%), center center, url(/static/bg_01.jpg);`
      }
    },
    created () {
      console.log('redirect ' + this.$route.query.redirect)
    }
  }
</script>
<style>
  a { 
    text-decoration: none;
  }
  .card__media {
    padding: 10px;
  }
  .card__media__background {
    position: relative;
  }
  .fundo {
    background-repeat: no-repeat;
    background-size: cover !important;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?14f815e8